var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D66FF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.75,21.86c-2.05,0-3.93,1.03-5.04,2.76c-0.25,0.39-0.14,0.91,0.25,1.16c0.39,0.25,0.91,0.14,1.16-0.25 c0.8-1.24,2.16-1.99,3.63-1.99s2.83,0.74,3.63,1.99c0.16,0.25,0.43,0.39,0.71,0.39c0.16,0,0.31-0.04,0.45-0.13 c0.39-0.25,0.5-0.77,0.25-1.16C24.68,22.89,22.8,21.86,20.75,21.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.89,17.24c-3.07-3.51-7.49-5.52-12.14-5.52s-9.07,2.01-12.14,5.52c-0.31,0.35-0.27,0.88,0.08,1.18 c0.35,0.31,0.88,0.27,1.18-0.08c2.75-3.14,6.71-4.95,10.88-4.95s8.13,1.8,10.88,4.95c0.17,0.19,0.4,0.29,0.63,0.29 c0.2,0,0.39-0.07,0.55-0.21C33.16,18.12,33.2,17.59,32.89,17.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.75,16.62c-3.39,0-6.56,1.51-8.71,4.15c-0.29,0.36-0.24,0.89,0.12,1.18c0.36,0.29,0.89,0.24,1.18-0.12 c1.83-2.24,4.53-3.53,7.41-3.53s5.58,1.29,7.41,3.53c0.17,0.2,0.41,0.31,0.65,0.31c0.19,0,0.37-0.06,0.53-0.19 c0.36-0.29,0.41-0.82,0.12-1.18C27.31,18.13,24.14,16.62,20.75,16.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.75,25.93c-1.06,0-1.93,0.86-1.93,1.93c0,1.06,0.86,1.93,1.93,1.93s1.93-0.86,1.93-1.93 C22.68,26.79,21.81,25.93,20.75,25.93z M20.75,27.79c0.03,0,0.06,0.03,0.06,0.06c0,0.07-0.12,0.07-0.12,0 C20.69,27.82,20.72,27.79,20.75,27.79z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon_1.47c8f1f3d55ecc19dfd356f6aab9cb9f.svg";
export { ForwardRef as ReactComponent };